namespace ui
{
	export namespace utils
	{
		export namespace UUID
		{
			function s4(): string
			{
				return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
			}

			export function Gen(): string
			{
				return	( s4() + s4() ) + '-' +
								( s4() ) + '-' +
								( s4() ) + '-' +
								( s4() ) + '-' +
								( s4() + s4() + s4() );
			}
		}
	}
}
